const comMeta = { lang: 'zh' }

const salonTax = [
  {
    path: '/invite-job',
    name: `invite-job`,
    component: () => import('@/views/inviteJob'),
    meta: {
      ...comMeta,
      title: '招聘',
      metaInfo: {
        title: '华盟·税纪云 _招聘'
      }
    }
  },
  {
    path: '/social-recruitment',
    name: `social-recruitment`,
    component: () => import('@/views/inviteJob/social-recruitment'),
    meta: {
      ...comMeta,
      title: '社会招聘',
      metaInfo: {
        title: '社会招聘'
      }
    }
  },
  {
    path: '/campus-recruitment',
    name: `campus-recruitment`,
    component: () => import('@/views/inviteJob/social-recruitment/campus-recruitment'),
    meta: {
      ...comMeta,
      title: '校园招聘',
      metaInfo: {
        title: '校园招聘'
      }
    }
  },
  {
    path: '/social-recruitment-detail',
    name: `social-recruitment-detail`,
    component: () => import('@/views/inviteJob/social-recruitment/social-recruitment-detail'),
    meta: {
      ...comMeta,
      title: '职位详情',
      metaInfo: {
        title: '职位详情'
      }
    }
  },
  {
    path: '/hm-style',
    name: `hm-style`,
    component: () => import('@/views/inviteJob/hm-style'),
    meta: {
      ...comMeta,
      title: '华盟风采',
      metaInfo: {
        title: '华盟风采'
      }
    }
  },
  {
    path: '/member-activity-detail',
    name: `member-activity-detail`,
    component: () => import('@/views/inviteJob/hm-style/member-activity-detail'),
    meta: {
      ...comMeta,
      title: '华盟风采',
      metaInfo: {
        title: '华盟风采'
      }
    }
  }
]

export default salonTax



// WEBPACK FOOTER //
// ./src/router/modules/invite-job.js